/**
 * Shared utility to extract searchable text from any canvas item.
 * Used by: embedding generation, board-clusters, partnr-chat context, search.
 *
 * Returns raw text without truncation — callers truncate as needed.
 */

const stripHtml = (html: string): string =>
  html.replace(/<[^>]*>/g, '').trim();

export function extractItemText(item: {
  item_type: string;
  content: Record<string, unknown>;
}): string {
  const c = item.content || {};

  switch (item.item_type) {
    case 'sticky':
      return (c.text as string) || '';

    case 'text_card': {
      const title = (c.title as string) || '';
      const body = stripHtml((c.body as string) || '');
      return [title, body].filter(Boolean).join(': ');
    }

    case 'document': {
      const title = (c.title as string) || '';
      const body = stripHtml((c.body as string) || '');
      return [title, body].filter(Boolean).join(': ');
    }

    case 'image': {
      const alt = (c.alt as string) || '';
      const analysis = (c.analysis as string) || '';
      return [alt, analysis].filter(Boolean).join(' — ');
    }

    case 'link': {
      const title = (c.title as string) || '';
      const description = (c.description as string) || '';
      const url = (c.url as string) || '';
      return [title, description, url].filter(Boolean).join(' — ');
    }

    case 'video': {
      const filename = (c.filename as string) || '';
      const aiDescription = (c.aiDescription as string) || '';
      return [filename, aiDescription].filter(Boolean).join(' — ');
    }

    case 'file':
      return (c.filename as string) || '';

    case 'board_link':
      return (c.boardName as string) || '';

    case 'synced_item':
      return (c.text as string) || (c.title as string) || '';

    default:
      return '';
  }
}
